var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout',{style:({
    minHeight: '100vh'
  })},[_c('a-layout-content',[_c('h1',[_vm._v("Archívum")]),_c('FadePopTransition',[_c('router-view',{staticClass:"login-view-card-container "})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }